import { ALPHA2_COUNTRY_CODES } from 'constants/countries.constants';
import { SAR_TO_AED_CONVERSION_RATE } from 'constants/currency.constants';
import { TabbyCountriesAndCurrenciesMapping } from 'constants/tickets.constants';

export const isCustomerFromUAE = (countryCode: string | undefined) => {
  return (
    countryCode &&
    countryCode === TabbyCountriesAndCurrenciesMapping['AE']?.countryCode
  );
};

const isValidCountryCode = (
  code: string,
): code is (typeof ALPHA2_COUNTRY_CODES)[number] => {
  return ALPHA2_COUNTRY_CODES.includes(
    code as (typeof ALPHA2_COUNTRY_CODES)[number],
  );
};

export const isCustomerFromRussia = (countryCode?: string) => {
  return (
    !!countryCode && isValidCountryCode(countryCode) && countryCode === 'RU'
  );
};

/**
 * Converts SAR amount to AED amount using precise calculations.
 * @param sarAmount - The amount in SAR to convert
 * @returns The converted amount in AED
 */
export const convertSarToAed = (sarAmount: number): number => {
  // Convert to smallest unit to avoid floating point issues
  const sarInFils = Math.round(sarAmount * 100);
  const aedInFils = Math.round(sarInFils * SAR_TO_AED_CONVERSION_RATE);

  // Round to 2 decimal places for currency precision
  return Math.round((aedInFils / 100) * 100) / 100;
};
